<app-dialog [showHeader]="false" [show]="show" minWidth="680" [id]="dialogId">
  <div class="amend-header" [tabindex]="0" #header>
    Amending
  </div>

  <div class="amend-sub-header">
    This action may only be performed once per record
  </div>
  <app-alert [show]="showWitnessMessage" [hasCustomCloseButton]="true" (closeOnButton)="hideAlibiWarning()"
             [type]="AlertTypesEnum.Info" [message]="'Witness needed for this transaction'"
             [description]="'You\'ll need an alibi to complete transaction'"></app-alert>

  <form [formGroup]="amendForm" (ngSubmit)="amendTransaction()" class="drug-form-container amend-dialog-container">
    <div class="flex flex-row space-x-4">
      <app-dropdown formControlName="amendReason" class="!w-[150%]"
        [isOptionObject]="true" [placeholder]="'Select a reason...'"
        [label]="'Why are you amending this record?'" (chosenOption)="changeReason($event)"
        [options]="amendReasons"
        [highlightFocusedInput]="true"
        #amendReasonDropdown>
      </app-dropdown>
      <app-datepicker-input [tabInd]="0"
            label="Transaction Date/Time"
            pickerType="both"
            formControlName="transactionDateDisplayValue"
            (dateTimeChange)="dateTimeChanged($event)"
            (inputTabKeyDown)="datePickerTabKey()"
            [dateMax]="now()"
            calendarPosition="right"
            #transactionDatePicker>
      </app-datepicker-input>
    </div>
    <div [class.hidden]="amendForm.value.amendReason !== AmendReason.Other" class="mb-3 -mt-2">
      <app-input
        formControlName="amendReasonOtherDescription"
        label="Describe Amend Reason"
        type="text"
        (keyupEnter)="focusControls()" (keydownTab)="inputTabKey()"
        #otherAmendReason
      ></app-input>
    </div>
    <div class="amend-details-container">
      <div class="record-details-container">
        <div *ngIf="transaction?.drug?.friendlyName || transaction?.drug.packageNdc" class="details-row">
          <div class="details-item">
            <div class="label">
              Drug
            </div>
            <div class="data">
              {{transaction?.drug.friendlyName}}
            </div>
          </div>
          <div class="details-item">
            <div class="label">
              NDC
            </div>
            <div class="data">
              {{transaction?.drug?.packageNdc}}
            </div>
          </div>
          <div class="details-item">
            <div class="label">
              Original Activity
            </div>
            <div class="data">
             {{(getMostRecentTransaction() | transactionBadge)?.label}}
            </div>
          </div>
          
        </div>

        <div *ngIf="getMostRecentTransaction()?.startingQuantity || getMostRecentTransaction()?.activityType"
             class="details-row">
        <div class="details-item">
          <div class="label">
            {{getTransactionCountDescription()}}
          </div>
          <div class="data">
            {{getMostRecentAdjustment() | absoluteValue}}
          </div>
        </div>
        <ng-container *ngIf="transaction?.transactionDate || (transaction?.firstName && transaction?.lastName)">
          <div class="details-item">
            <div class="label">
              Date/Time
            </div>
            <div class="data">
              {{getMostRecentTransaction()?.transactionDate | formattedDate: 'MM d a, HH:mm'}}
            </div>
          </div>
          <div class="details-item">
            <div class="label">
              Recorded By
            </div>
            <div class="data">
              {{getMostRecentTransaction()?.firstName}} {{getMostRecentTransaction()?.lastName[0]}}.
            </div>
          </div>
        </ng-container>
      </div>
      <div class="details-row"
      *ngIf="transaction?.activityType === ActivityTypesEnum.Dispensed && (transaction?.rxNumber || transaction?.patientName)">
        <div class="details-item-3-row">
          <div class="label">
            Rx Number
          </div>
          <div class="data">
            {{getMostRecentTransaction() | rxNumber}}
          </div>
        </div>
        <div class="details-item-3-row">
          <div class="label">
            Patient Name
          </div>
          <div class="data">
            {{getMostRecentTransaction()?.patientName}}
          </div>
        </div>
     </div>
    </div>
     <!-- regular amend -->
    <div *ngIf="transaction?.activityType !== ActivityTypesEnum.Compounded">
      <ng-container *ngIf="isIncorrectQuantityReason(); then incorrectQuantity"></ng-container>
      <ng-container *ngIf="isOtherReason(); then otherReasons"></ng-container>
      <ng-container *ngIf="isReturnToWholesalerReason(); then returnToWholesaler"></ng-container>

      <div *ngIf="amendForm.get('amendReason')?.value === AmendReason.RecordedIncorrectRxNumberAndOrPatientName" class="inventory-count-container">
        <div class="inventory-count-header">
          Amend
        </div>
        <ng-container *ngTemplateOutlet="table; context: { 
          $implicit: getCurrentInventoryCountForTransactionDrug(), 
          amended: getCalculatedAdjustment(),
          calculatedOnHand: getIncorrectQuantityCalculatedAvailableCount(),
          withBackCountCol: true
        }"
        ></ng-container>

        <div class="inventory-items mt-4 rounded-md">
          <div class="inventory-item rx-number">
            <div class="label">Rx Number</div>
            <div class="value">
              <app-input [showErrors]="false" placeholder="0000000-00000" formControlName="rxNumber" type="text"
                         (keyupEnter)="focusInput('patientNameInput')" #rxNumberInput></app-input>
            </div>
          </div>
          <div class="inventory-item patient-name">
            <div class="label">Patient Name</div>
            <div class="value">
              <app-input [showErrors]="false" placeholder="John Smith" formControlName="patientName" type="text"
                         (keyupEnter)="amendTransaction()" (keydownTab)="inputTabKey()" #patientNameInput></app-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- compound amend -->
    <div *ngIf="transaction?.activityType === ActivityTypesEnum.Compounded && amendForm.get('amendReason')?.value" 
      class="-ml-8 -mr-8">
      <app-compound-amend-table *ngIf="(ingredientsAndWasteForTheCurrentAmend$ | async)?.length"
        [compound]="transaction"
        [ingredientsWasteData]="ingredientsAndWasteForTheCurrentAmend$ | async"
        [form]="compoundForm"
        [compoundCurrentInventory]="currentInventoryCountForTransactionDrug || transaction?.endingQuantity"
      ></app-compound-amend-table>
    </div>

    </div>

    <div class="dialog-controls-default hide-controls-divider">
      <!-- Validation: {{formErrors | json}} -->
      <app-button class="cancel-btn" [subStyle]="'transparent'" [text]="'Cancel'" (clicked)="cancelAmend()"
        (keydownTab)="amendReasonDropdown.focus()" #cancelBtn>
      </app-button>

      <app-button class="save-btn" [text]="'Amend'" [type]="'submit'"
        (keydownTab)="amendReasonDropdown.focus()" #submitBtn></app-button>
    </div>

  </form>
</app-dialog>


<ng-template [formGroup]="amendForm" #incorrectQuantity>
  <div class="inventory-count-container incorrect-qty-reason">
    <div class="inventory-count-header">
      Inventory
    </div>

  <ng-container *ngTemplateOutlet="table; context: { 
    $implicit: getCurrentInventoryCountForTransactionDrug(), 
    amended: getCalculatedAdjustment(),
    calculatedOnHand: getIncorrectQuantityCalculatedAvailableCount(),
    withBackCountCol: false
  }"
  ></ng-container>
  <div class="inventory-items incorrect-qty" [class.with-location]="inventoryLocationsEnabled$ | async">
    <div class="inventory-item count">
      <div class="label">What quantity did you intend to record instead of {{getMostRecentAdjustment() |absoluteValue | number}}?</div>
      <div class="value">
        <app-input [showErrors]="false"
                   [textAlign]="'right'"
                   formControlName="addedQuantity"
                   type="number"
                   (keyupEnter)="amendTransaction()"
                   (keydownTab)="inputTabKey()"
                   #addedQuantityInput
        ></app-input>
      </div>
    </div>
    <div class="inventory-item on-hand">
      <div class="label">On-Hand</div>
      <div class="value">{{getIncorrectQuantityCalculatedOnHandCount()}}</div>
      <div *ngIf="backCountEnabled && amendForm.controls.addedQuantity.value" class="flex ml-8 items-center">
        <span class="back-count-ok">Back-Count OK?</span>
        <app-yes-no-toggle
          [control]="amendForm.controls.isBackCountMatches"
        ></app-yes-no-toggle>
      </div>
    </div>
  </div>
  <app-error-message *ngIf="amendForm.get('addedQuantity').hasError('originalPendingTransactionCountExceeded')">
      {{amendForm.get('addedQuantity').getError('originalPendingTransactionCountExceeded')}}
  </app-error-message>
  </div>
</ng-template>

<ng-template [formGroup]="amendForm" #returnToWholesaler>
  <div class="inventory-count-container">
    <div class="inventory-count-header">
      Inventory
    </div>
    <div class="inventory-items">
      <div class="inventory-item starting">
        <div class="label">Starting Count</div>
        <div class="value">{{getCurrentInventoryCountForTransactionDrug()}}</div>
      </div>
      <div class="inventory-item count">
        <div class="label">What quantity do you intend to return?</div>
        <div class="value">
          <app-input [showErrors]="false"
                     [textAlign]="'right'"
                     formControlName="addedQuantity"
                     type="number"
                     (keyupEnter)="amendTransaction()"
                     (keydownTab)="inputTabKey()"
                     #addedQuantityInput
          ></app-input>
        </div>
      </div>
      <div class="inventory-item on-hand">
        <div class="label">On-Hand</div>
        <div class="value">{{getReturnToWholesalerCalculatedOnHandCount()}}</div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template [formGroup]="amendForm" #otherReasons>
  <div class="inventory-count-container">
    <div class="inventory-count-header">
      Inventory
    </div>

    <ng-container *ngTemplateOutlet="table; context: { 
      $implicit: getCurrentInventoryCountForTransactionDrug(), 
      amended: getCalculatedAdjustment(),
      calculatedOnHand: getCalculatedNewOnHand(),
      withBackCountCol: true
    }"
    ></ng-container>
  </div>
</ng-template>

<ng-template #table let-start let-amended="amended" let-calculatedOnHand="calculatedOnHand" let-withBackCountCol="withBackCountCol">
  <table class="table-primary" [formGroup]="amendForm"> 
    <thead>
        <tr>
            <th class="text-left drug" scope="col">
                Drug
            </th>
            <th class="text-left location" scope="col" *ngIf="inventoryLocationsEnabled$ | async">
                Location
            </th>
            <th class="text-right starting" scope="col">
                Starting
            </th>
            <th class="text-right count" scope="col">
                Count
            </th>
            <th class="text-right on-hand !pl-0" scope="col">
                On-Hand
            </th>
            <th class="text-left back-count" scope="col" *ngIf="backCountEnabled">
                <span *ngIf="withBackCountCol">BACK-COUNT OK?</span>
            </th>
        </tr>
    </thead>
    <tbody>
        <tr class="table-row">
            <td class="text-left drug" >
                <div class="heading">
                    {{transaction?.drug.friendlyName}} 
                </div>
                <div class="secondary flex">
                    {{transaction?.drug?.packageNdc}}
                </div>
            </td>
            <td class="location" *ngIf="inventoryLocationsEnabled$ | async"> 
                {{transaction?.locationName}}
            </td>
            <td class="text-right starting">{{start}}</td>
            <td class="text-right count">
                {{amended}}
            </td>

            <td class="text-right on-hand">
                {{calculatedOnHand| number}}
                <app-back-count-not-resolved-tooltip *ngIf="backCountEnabled"
                  [locationID]="transaction?.locationID"
                  [drugID]="transaction?.drug?.id"
                ></app-back-count-not-resolved-tooltip>
            </td>

            <td class="text-left back-count" *ngIf="backCountEnabled">
              <app-yes-no-toggle *ngIf="withBackCountCol"
                [control]="amendForm.controls.isBackCountMatches"
              ></app-yes-no-toggle>
            </td>
        </tr>
    </tbody>
  </table>
</ng-template>